import {serverSideTranslations} from 'next-i18next/serverSideTranslations';
import {findAsync} from '../lib/api/rest/strapi';
import {paths} from '../lib/api/rest/paths';
import {useTranslation} from 'next-i18next';
import {TextLayoutPage} from '../components/layout/textLayoutPage';
import SimpleCard from '../components/simpleComponents/simpleCard';
import qs from 'qs';

export default function ShippingTypes({shippingTypes}) {
  const {t: translateSiteMeta} = useTranslation('site-meta');
  const {t: translatePages} = useTranslation('pages');

  return <TextLayoutPage title={translatePages('SHIPPING_TYPES.TITLE')}
                         description={translateSiteMeta(
                             'SHIPPING_TYPES_META_DESCRIPTION')}>


    <div className={'grid grid-cols-7 mt-4'}>

      <div
          className={'col-span-2 bg-gray-100 p-2 border border-gray-200 break-words'}>
        {translatePages('SHIPPING_TYPES.TABLE.HEADER_1')}
      </div>
      <div
          className={'col-span-3 bg-gray-100 p-2 border border-gray-200 break-words'}>
        {translatePages('SHIPPING_TYPES.TABLE.HEADER_2')}
      </div>
      <div
          className={'col-span-2 bg-gray-100 p-2 border border-gray-200 break-words'}>
        {translatePages('SHIPPING_TYPES.TABLE.HEADER_3')}
      </div>

      <TableRow col1={translatePages('SHIPPING_TYPES.TABLE.ROW_1.COL_1')}
                col2={translatePages('SHIPPING_TYPES.TABLE.ROW_1.COL_2')}
                col3={translatePages('SHIPPING_TYPES.TABLE.ROW_1.COL_3')}
      />
      <TableRow col1={translatePages('SHIPPING_TYPES.TABLE.ROW_2.COL_1')}
                col2={translatePages('SHIPPING_TYPES.TABLE.ROW_2.COL_2')}
                col3={translatePages('SHIPPING_TYPES.TABLE.ROW_2.COL_3')}
      />

    </div>

    <div className={'mt-5 text-sm text-gray-800'}>
      <p>
        {translatePages('SHIPPING_TYPES.DESCRIPTION_1')}
      </p>
      <p>
        {translatePages('SHIPPING_TYPES.DESCRIPTION_2')}
      </p>

      <p>
        {translatePages('SHIPPING_TYPES.DESCRIPTION_3')}
      </p>
      <p>
        {translatePages('SHIPPING_TYPES.DESCRIPTION_4')}
      </p>
    </div>
  </TextLayoutPage>;
}

export async function getStaticProps({locale, defaultLocale}) {

  let _query = {_sort: 'id'};

  const query = qs.stringify(_query);

  const shippingTypes = await findAsync(paths.SHIPPING_COURIERS, false, query,
      false);

  return {
    props: {
      shippingTypes,
      ...(await serverSideTranslations(locale,
          ['common', 'pages', 'products', 'site-meta', 'menu'])),
    },
  };
}

const TableRow = ({col1, col2, col3}) => {

  return <>
    <div
        className={'col-span-2 p-2 border-r border-b border-l text-gray-700 break-words'}>
      {col1}
    </div>
    <div
        className={'col-span-3 p-2 border-r border-b text-gray-700 break-words'}>
      {col2}
    </div>
    <div
        className={'col-span-2 p-2 border-b border-l border-r text-gray-700 break-words'}>
      {col3}
    </div>
  </>;

};
